// src/api/apiClient.js
import axios from 'axios';
import API_SETTINGS from './settingsApi';

const apiClient = (subdomain) => {
    const baseURL = API_SETTINGS.getBaseUrl(`${subdomain}`);
    const instance = axios.create({
        baseURL,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true, // важное
    });

    instance.interceptors.response.use(
        (r) => r,
        (error) => {
            if (error.response?.status === 401) {
                // не трогаем localStorage — его больше не используем для токена
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

export default apiClient;
